import React, { useEffect, useState } from 'react';
import { HiOutlineChatBubbleLeftRight, HiOutlinePaperAirplane } from 'react-icons/hi2';
import UserAvatar from '../UserAvatar/UserAvatar';
import axios from '../../Actions/axios.config';
import { useSelector } from 'react-redux';
import ReplyCommentCard from './ReplyCommentCard';

const ReplyComment = ({ comment, handleCommentReply }) => {
  const [replyText, setReplyText] = useState('');
  const [replies, setReplies] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useSelector((state) => state.user);

  // Fetch replies
  const fetchReplies = async () => {
    try {
      const res = await axios.get(`/comments/getReplies/${comment._id}`);
      setReplies(res.data.replies);
    } catch (e) {
      console.error("Error fetching replies:", e);
    }
  };

  useEffect(() => {
    fetchReplies();
  }, [comment._id]);

  const handleSubmit = async () => {
    if (!replyText.trim()) return;
    setIsSubmitting(true);

    const postReply = {
      text: replyText,
      user: user._id,
      userName: user.name,
      createdAt: new Date(),
      comment: comment._id,
      likes: [],
    };

    try {
      await axios.post('/comments/reply', postReply);
      
      // Optimistic Update: Add to list immediately
      setReplies([...replies, postReply]);
      setReplyText('');
    } catch (e) {
      console.log(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mt-4 space-y-4">
      {/* 1. Replies List */}
      <div className="space-y-4">
        {replies && replies.map((replyItem, index) => (
          <div key={index} className="animate-in fade-in slide-in-from-left-2 duration-300">
            <ReplyCommentCard 
              comment={replyItem} 
              handleCommentReply={handleCommentReply} 
            />
          </div>
        ))}
      </div>

      {/* 2. Reply Input Box */}
      <div className="flex items-start gap-3 p-3 bg-slate-50/50 rounded-3xl border border-slate-100 mt-6">
        <UserAvatar src={user?.profileImage} name={user?.name} size={28} className="mt-1 flex-shrink-0" />
        
        <div className="flex-grow relative">
          <textarea
            rows="1"
            placeholder={`Reply to ${comment.userName}...`}
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
            onInput={(e) => {
              e.target.style.height = 'auto';
              e.target.style.height = e.target.scrollHeight + 'px';
            }}
            className="w-full bg-transparent text-sm font-medium py-2 pr-12 outline-none resize-none text-slate-700 placeholder:text-slate-400"
          />
          
          <button
            onClick={handleSubmit}
            disabled={isSubmitting || !replyText.trim()}
            className={`absolute right-0 bottom-1 p-2 rounded-xl transition-all ${
              replyText.trim() 
                ? 'text-blue-600 bg-blue-50 hover:bg-blue-100' 
                : 'text-slate-300 bg-transparent'
            }`}
          >
            <HiOutlinePaperAirplane size={18} className={isSubmitting ? 'animate-pulse' : ''} />
          </button>
        </div>
      </div>

      {/* 3. Helper Label */}
      <p className="text-[10px] font-black text-slate-300 uppercase tracking-widest ml-12">
        Replying as <span className="text-blue-500">{user.name}</span>
      </p>
    </div>
  );
};

export default ReplyComment;